import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { take } from 'rxjs';
import { TextPopupComponent } from '../../basic/text-popup/text-popup.component';
import { BoardService } from '../../core/board/board.service';
import { GoalService } from '../../core/goal/goal.service';
import { MethodologyService } from '../../core/methodology/methodology.service';
import { ProductService } from '../../core/product/product.service';
import { UnipileService } from '../../core/unipile/unipile.service';
import { WorkspaceHolderService } from '../../core/workspace/workspace.holder.service';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';
import { MainSidebarComponent } from '../_shared/main-sidebar/main-sidebar.component';
import { BoardHolderService } from './../../core/board/board.holder.service';
import { UserClerkService } from './../../core/user/user-clerk.service';

@Component({
  selector: 'app-my-account',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    NzButtonModule,
    NzInputModule,
    NzIconModule,
    NzAvatarModule,
    NzPopconfirmModule,
    NzPopoverModule,
    NzInputNumberModule,
    NzSelectModule,

    MainSidebarComponent,
    BasicPageComponent,
    TextPopupComponent,
  ],
  templateUrl: './my-account.component.html',
  styleUrl: './my-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyAccountComponent {
  constructor(
    private goalService: GoalService,
    private boardService: BoardService,
    private messageService: NzMessageService,
    private unipileService: UnipileService,
    private productService: ProductService,
    private userClerkService: UserClerkService,
    private boardHolderService: BoardHolderService,
    private workspaceHolderService: WorkspaceHolderService,
    private methodologyService: MethodologyService
  ) {}

  @ViewChild('userProfile', { static: true })
  private clerkUserProfile?: ElementRef;

  productList = toSignal(this.productService.productList$(), { initialValue: [] });
  goalList = toSignal(this.goalService.goalList$(), { initialValue: [] });
  methodologyList = toSignal(this.methodologyService.methodologyList$(), { initialValue: [] });

  ngAfterViewInit() {
    this.userClerkService
      .init$()
      .pipe(take(1))
      .subscribe(() => {
        this.userClerkService.mountUserProfile(this.clerkUserProfile!.nativeElement);
      });
  }

  currentWorkspace = computed(() => {
    return this.workspaceHolderService.currentWorkspace();
  });

  myPersonalBoard = computed(() => {
    const personalBoard = this.boardHolderService.myPersonalBoard();

    if (!personalBoard!.userBoardConfig!.linkedInMessageCharsLimit) {
      personalBoard!.userBoardConfig!.linkedInMessageCharsLimit = 200;
    }

    return personalBoard;
  });

  getEmail() {
    return this.userClerkService.getEmail();
  }

  onSyncClick() {
    this.myPersonalBoard()!.userBoardConfig!.preferredName = this.userClerkService.getUser()?.firstName ?? '';
    this.myPersonalBoard()!.userBoardConfig!.lastName = this.userClerkService.getUser()?.lastName ?? '';
    this.myPersonalBoard()!.userBoardConfig!.portraitUrl = this.userClerkService.getUser()?.imageUrl ?? '';
    this.onSaveClick();
  }

  onSaveClick() {
    this.boardHolderService.updateMyPersonalBoard$().pipe(take(1)).subscribe();
  }

  //#region Unipile
  isConnectedToUnipile = toSignal(this.unipileService.isConnected$());

  isUnipileVisible = false;
  connectUnipileDescriptionMarkdown = `
### Please contact us to get the account id.
- hello@peakmojo.ai
  `;

  onConnectUnipileCancel() {
    this.isUnipileVisible = false;
  }

  onConnectUnipileClick(accountId: string) {
    this.boardService
      .updateUnipile$(accountId)
      .pipe(take(1))
      .subscribe(() => {
        this.isUnipileVisible = false;
        this.messageService.success('Connect HubSpot successfully.');
        window.location.reload();
      });
  }
  //#endregion Unipile
}
